import type { LinkProps as LinkPropsMui } from '@mui/material';
import { Link as LinkMui } from '@mui/material';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

type LinkProps = Omit<
  Omit<LinkPropsMui, 'component'> & RouterLinkProps,
  'href'
>;

const Link = ({ children, ...props }: LinkProps) => {
  return (
    <LinkMui {...props} component={RouterLink}>
      {children}
    </LinkMui>
  );
};

export default Link;
